"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modalPhrases = modalPhrases;
exports.deriveRuleModality = deriveRuleModality;
const implementation_rules_1 = require("./implementation-rules");
function modalPhrases() {
    return [
        { modality: implementation_rules_1.RuleModality.MustNot, phrase: 'must not', pattern: /\bmust not\b/i },
        { modality: implementation_rules_1.RuleModality.ShouldNot, phrase: 'should not', pattern: /\bshould not\b/i },
        { modality: implementation_rules_1.RuleModality.Must, phrase: 'must', pattern: /\bmust\b/i },
        { modality: implementation_rules_1.RuleModality.Should, phrase: 'should', pattern: /\bshould\b/i },
    ];
}
function deriveRuleModality(ruleText) {
    for (const { pattern, modality } of modalPhrases()) {
        if (pattern.test(ruleText)) {
            return { kind: 'derived', modality };
        }
    }
    return { kind: 'underivable' };
}
//# sourceMappingURL=derive-rule-modality.js.map